import { tap, catchError, map, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { Command } from '../../../core/model/command';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { MessageService } from '../../../core/service/message.service';
import { SendRegistrationKeyFormComponent } from '../../component/send-registration-key-form/send-registration-key-form.component';
import { tenantCommand } from '../../model/const/command';

@Injectable()
export class SendRegistrationKeyCommandHandler implements ICommandHandler {
  constructor(
    private _actionService: ActionWindowService,
    private _client: HttpClient,
    private _injector: Injector,
    private _messageService: MessageService,
    @Inject(APP_CONFIG) private _config: IAppConfig
  ) {}

  canExecute(command: Command): boolean {
    return command.id === tenantCommand.sendRegistrationKey && command.context;
  }

  execute(command: Command): Observable<void> {
    return this._actionService
      .open(SendRegistrationKeyFormComponent, this._injector, [{ provide: 'defaultEmail', useValue: command.context.email }])
      .pipe(
        switchMap(result => {
          return this._client
            .post(`${this._config.tenantEndpoint}/send-key`, JSON.stringify({ id: command.context.id, email: result.email }))
            .pipe(
              map(status => {
                command.context.status = status;
                this._actionService.close();
              }),
              catchError(error => {
                this._messageService.showError(error);
                return [];
              }),
              tap(() => this._messageService.showSuccess('SUCCESS.REGISTRATION_KEY_SENT'))
            );
        })
      );
  }
}
